/* eslint-disable no-shadow */

export namespace BackendEnums {

export enum AICompletionStatusEnum {
'PENDING' = 'pending',
'COMPLETED' = 'completed',
'FAILED' = 'failed',
}

export enum ActionTypeEnum {
'SEND_RATING_EMAIL' = 'SEND_RATING_EMAIL',
'SEND_MESSAGE_TEMPLATE' = 'SEND_MESSAGE_TEMPLATE',
'SEND_SMS' = 'SEND_SMS',
'ADD_DEADLINE' = 'ADD_DEADLINE',
'ASSIGN_AGENT' = 'ASSIGN_AGENT',
'UNASSIGN_AGENT' = 'UNASSIGN_AGENT',
'ADD_DOCUMENT' = 'ADD_DOCUMENT',
'ADD_TRANSPORT' = 'ADD_TRANSPORT',
'ADD_TAG' = 'ADD_TAG',
'REMOVE_TAG' = 'REMOVE_TAG',
'CLOSE_TICKET' = 'CLOSE_TICKET',
'REOPEN_TICKET' = 'REOPEN_TICKET',
'CHANGE_STATE' = 'CHANGE_STATE',
'ORDER_REQUESTED_SHIPPING' = 'ORDER_REQUESTED_SHIPPING',
'ADD_ACTIVITY' = 'ADD_ACTIVITY',
'FILL_CUSTOM_FIELD' = 'FILL_CUSTOM_FIELD',
}

export enum ActivityStatusEnum {
'STATUS_OPEN' = 'STATUS_OPEN',
'STATUS_CLOSED' = 'STATUS_CLOSED',
}

export enum AgentInputRequestStatusEnum {
'PENDING' = 'pending',
'COMPLETED' = 'completed',
'EXPIRED' = 'expired',
'CANCELLED' = 'cancelled',
}

export enum ApprovalTriggerEnum {
'MANUAL' = 'MANUAL',
'IMMEDIATE' = 'IMMEDIATE',
'TICKET_STATE' = 'TICKET_STATE',
}

export enum AutomationScopeEnum {
'DRAFTS' = 'DRAFTS',
'ORDERS' = 'ORDERS',
'DOCUMENTS' = 'DOCUMENTS',
}

export enum BilledInvoiceStatusEnum {
'DRAFT' = 'DRAFT',
'FINALIZED' = 'FINALIZED',
'AWAITING_PAYMENT' = 'AWAITING_PAYMENT',
'REQUIRES_ACTION' = 'REQUIRES_ACTION',
'RETRYING' = 'RETRYING',
'PAID' = 'PAID',
'UNCOLLECTIBLE' = 'UNCOLLECTIBLE',
'REFUNDED' = 'REFUNDED',
'VOIDED' = 'VOIDED',
'FAIL' = 'FAIL',
}

export enum BillingCurrencyEnum {
'CZK' = 'CZK',
'EUR' = 'EUR',
}

export enum BillingIssueEnum {
'BLOCKED_NEED_CARD' = 'BLOCKED_NEED_CARD',
'NEED_CARD' = 'NEED_CARD',
'REQUIRES_AUTHENTICATION' = 'REQUIRES_AUTHENTICATION',
}

export enum BillingSchemeEnum {
'PER_UNIT' = 'PER_UNIT',
'TIERED' = 'TIERED',
'EXTERNAL' = 'EXTERNAL',
}

export enum BulkActionActionEnum {
'CLOSE' = 'close',
'DELETE' = 'delete',
'ASSIGN' = 'assign',
'STATE_CHANGE' = 'state_change',
'ADD_TAGS' = 'add_tags',
'REMOVE_TAGS' = 'remove_tags',
'EXPORT_TICKETS' = 'export_tickets',
'EXPORT_PRODUCTS' = 'export_products',
'EXPORT_PDF' = 'export_pdf',
}

export enum ButtonRadiusEnum {
'NONE' = 'none',
'SM' = 'sm',
'MD' = 'md',
'LG' = 'lg',
'FULL' = 'full',
}

export enum CapabilityEnum {
'TICKETS_VIEW' = 'tickets.view',
'TICKETS_WORK' = 'tickets.work',
'TICKETS_WRITE_TO_CUSTOMER' = 'tickets.write_to_customer',
'TICKETS_DELETE' = 'tickets.delete',
'TICKETS_SETTINGS' = 'tickets.settings',
'REFUNDS_VIEW' = 'refunds.view',
'REFUNDS_ISSUE' = 'refunds.issue',
'REFUNDS_SETTINGS' = 'refunds.settings',
'SHIPPING_VIEW' = 'shipping.view',
'SHIPPING_CREATE' = 'shipping.create',
'SHIPPING_SETTINGS' = 'shipping.settings',
'DATA_ORDERS' = 'data.orders',
'DATA_CUSTOMERS' = 'data.customers',
'DATA_STATS' = 'data.stats',
'DATA_EXPORT' = 'data.export',
'FLOWS_RUN' = 'flows.run',
'FLOWS_CONFIGURE' = 'flows.configure',
'INTEGRATIONS_MANAGE' = 'integrations.manage',
'INTEGRATIONS_MARKETPLACE' = 'integrations.marketplace',
'INTEGRATIONS_API_ACCESS' = 'integrations.api_access',
'INTEGRATIONS_MCP' = 'integrations.mcp',
'TEAM_MANAGE' = 'team.manage',
'BILLING_VIEW' = 'billing.view',
'BILLING_MANAGE' = 'billing.manage',
'COMPANY_SETTINGS' = 'company.settings',
'TRACKING_VIEW' = 'tracking.view',
'TRACKING_WORK' = 'tracking.work',
'TRACKING_SETTINGS' = 'tracking.settings',
}

export enum CapabilityGroupEnum {
'TICKETS' = 'tickets',
'REFUNDS' = 'refunds',
'SHIPPING' = 'shipping',
'DATA' = 'data',
'FLOWS' = 'flows',
'INTEGRATIONS' = 'integrations',
'TEAM' = 'team',
'COMPANY' = 'company',
'TRACKING' = 'tracking',
}

export enum CardProviderEnum {
'STRIPE' = 'STRIPE',
}

export enum ChoiceEnum {
'STANDARD' = 'standard',
'ADVANCED' = 'advanced',
}

export enum CompanyEmailSettingTypeEnum {
'TYPE_TRANSPORT_LABEL' = 'TYPE_TRANSPORT_LABEL',
'TYPE_TICKET_CREATED' = 'TYPE_TICKET_CREATED',
'TYPE_RATING' = 'TYPE_RATING',
'TYPE_DOCUMENT' = 'TYPE_DOCUMENT',
'TYPE_CREDIT_NOTE' = 'TYPE_CREDIT_NOTE',
'TYPE_VOUCHER' = 'TYPE_VOUCHER',
}

export enum CompanyOnboardingStepTypeEnum {
'BASE_SETTINGS' = 'BASE_SETTINGS',
'DATA_INTEGRATION' = 'DATA_INTEGRATION',
'WIDGET_INTEGRATION' = 'WIDGET_INTEGRATION',
'SHIPPING_SETTINGS' = 'SHIPPING_SETTINGS',
'PORTAL_INTEGRATION' = 'PORTAL_INTEGRATION',
'PORTAL_FIRST_TICKET' = 'PORTAL_FIRST_TICKET',
'TRACKING_SELECT_LANGUAGES' = 'TRACKING_SELECT_LANGUAGES',
'TRACKING_ORDER_INTEGRATION' = 'TRACKING_ORDER_INTEGRATION',
'TRACKING_CARRIER_SELECTION' = 'TRACKING_CARRIER_SELECTION',
'TRACKING_BRAND_IDENTITY' = 'TRACKING_BRAND_IDENTITY',
}

export enum CompanyOrderProviderProviderEnum {
'SHOPTET_API' = 'SHOPTET_API',
'RETINO_XML' = 'RETINO_XML',
'PRESTASHOP_16' = 'PRESTASHOP_16',
'UPGATES_API' = 'UPGATES_API',
'SHOPIFY_PRIVATE' = 'SHOPIFY_PRIVATE',
'SHOPIFY_API' = 'SHOPIFY_API',
'SIMPLIA_API' = 'SIMPLIA_API',
'SHOPRENTER_API' = 'SHOPRENTER_API',
'WEBAREAL_API' = 'WEBAREAL_API',
'SHOPWARE_5' = 'SHOPWARE_5',
'SHOPWARE_6' = 'SHOPWARE_6',
'BYZNYSWEB_API' = 'BYZNYSWEB_API',
'WOOCOMMERCE_API' = 'WOOCOMMERCE_API',
'RETINO_ORDERS_API' = 'RETINO_ORDERS_API',
'UNAS_API' = 'UNAS_API',
'ESHOP_RYCHLE_API' = 'ESHOP_RYCHLE_API',
'IDOSELL_API' = 'IDOSELL_API',
}

export enum CompanyOrderProviderStateEnum {
'READY' = 'READY',
'INIT' = 'INIT',
'FAILED' = 'FAILED',
'DISABLED' = 'DISABLED',
'STOPPED' = 'STOPPED',
}

export enum ConditionOperationEnum {
'AND' = 'AND',
'OR' = 'OR',
}

export enum CountryEnum {
'AF' = 'AF',
'AX' = 'AX',
'AL' = 'AL',
'DZ' = 'DZ',
'AS' = 'AS',
'AD' = 'AD',
'AO' = 'AO',
'AI' = 'AI',
'AQ' = 'AQ',
'AG' = 'AG',
'AR' = 'AR',
'AM' = 'AM',
'AW' = 'AW',
'AU' = 'AU',
'AT' = 'AT',
'AZ' = 'AZ',
'BS' = 'BS',
'BH' = 'BH',
'BD' = 'BD',
'BB' = 'BB',
'BY' = 'BY',
'BE' = 'BE',
'BZ' = 'BZ',
'BJ' = 'BJ',
'BM' = 'BM',
'BT' = 'BT',
'BO' = 'BO',
'BQ' = 'BQ',
'BA' = 'BA',
'BW' = 'BW',
'BV' = 'BV',
'BR' = 'BR',
'IO' = 'IO',
'BN' = 'BN',
'BG' = 'BG',
'BF' = 'BF',
'BI' = 'BI',
'CV' = 'CV',
'KH' = 'KH',
'CM' = 'CM',
'CA' = 'CA',
'KY' = 'KY',
'CF' = 'CF',
'TD' = 'TD',
'CL' = 'CL',
'CN' = 'CN',
'CX' = 'CX',
'CC' = 'CC',
'CO' = 'CO',
'KM' = 'KM',
'CD' = 'CD',
'CG' = 'CG',
'CK' = 'CK',
'CR' = 'CR',
'CI' = 'CI',
'HR' = 'HR',
'CU' = 'CU',
'CW' = 'CW',
'CY' = 'CY',
'CZ' = 'CZ',
'DK' = 'DK',
'DJ' = 'DJ',
'DM' = 'DM',
'DO' = 'DO',
'EC' = 'EC',
'EG' = 'EG',
'SV' = 'SV',
'GQ' = 'GQ',
'ER' = 'ER',
'EE' = 'EE',
'ET' = 'ET',
'FK' = 'FK',
'FO' = 'FO',
'FJ' = 'FJ',
'FI' = 'FI',
'FR' = 'FR',
'GF' = 'GF',
'PF' = 'PF',
'TF' = 'TF',
'GA' = 'GA',
'GM' = 'GM',
'GE' = 'GE',
'DE' = 'DE',
'GH' = 'GH',
'GI' = 'GI',
'GR' = 'GR',
'GL' = 'GL',
'GD' = 'GD',
'GP' = 'GP',
'GU' = 'GU',
'GT' = 'GT',
'GG' = 'GG',
'GN' = 'GN',
'GW' = 'GW',
'GY' = 'GY',
'HT' = 'HT',
'HM' = 'HM',
'VA' = 'VA',
'HN' = 'HN',
'HK' = 'HK',
'HU' = 'HU',
'IS' = 'IS',
'IN' = 'IN',
'ID' = 'ID',
'IR' = 'IR',
'IQ' = 'IQ',
'IE' = 'IE',
'IM' = 'IM',
'IL' = 'IL',
'IT' = 'IT',
'JM' = 'JM',
'JP' = 'JP',
'JE' = 'JE',
'JO' = 'JO',
'KZ' = 'KZ',
'KE' = 'KE',
'KI' = 'KI',
'KP' = 'KP',
'KR' = 'KR',
'KW' = 'KW',
'KG' = 'KG',
'LA' = 'LA',
'LV' = 'LV',
'LB' = 'LB',
'LS' = 'LS',
'LR' = 'LR',
'LY' = 'LY',
'LI' = 'LI',
'LT' = 'LT',
'LU' = 'LU',
'MO' = 'MO',
'MK' = 'MK',
'MG' = 'MG',
'MW' = 'MW',
'MY' = 'MY',
'MV' = 'MV',
'ML' = 'ML',
'MT' = 'MT',
'MH' = 'MH',
'MQ' = 'MQ',
'MR' = 'MR',
'MU' = 'MU',
'YT' = 'YT',
'MX' = 'MX',
'FM' = 'FM',
'MD' = 'MD',
'MC' = 'MC',
'MN' = 'MN',
'ME' = 'ME',
'MS' = 'MS',
'MA' = 'MA',
'MZ' = 'MZ',
'MM' = 'MM',
'NA' = 'NA',
'NR' = 'NR',
'NP' = 'NP',
'NL' = 'NL',
'NC' = 'NC',
'NZ' = 'NZ',
'NI' = 'NI',
'NE' = 'NE',
'NG' = 'NG',
'NU' = 'NU',
'NF' = 'NF',
'MP' = 'MP',
'NO' = 'NO',
'OM' = 'OM',
'PK' = 'PK',
'PW' = 'PW',
'PS' = 'PS',
'PA' = 'PA',
'PG' = 'PG',
'PY' = 'PY',
'PE' = 'PE',
'PH' = 'PH',
'PN' = 'PN',
'PL' = 'PL',
'PT' = 'PT',
'PR' = 'PR',
'QA' = 'QA',
'RE' = 'RE',
'RO' = 'RO',
'RU' = 'RU',
'RW' = 'RW',
'BL' = 'BL',
'SH' = 'SH',
'KN' = 'KN',
'LC' = 'LC',
'MF' = 'MF',
'PM' = 'PM',
'VC' = 'VC',
'WS' = 'WS',
'SM' = 'SM',
'ST' = 'ST',
'SA' = 'SA',
'SN' = 'SN',
'RS' = 'RS',
'SC' = 'SC',
'SL' = 'SL',
'SG' = 'SG',
'SX' = 'SX',
'SK' = 'SK',
'SI' = 'SI',
'SB' = 'SB',
'SO' = 'SO',
'ZA' = 'ZA',
'GS' = 'GS',
'SS' = 'SS',
'ES' = 'ES',
'LK' = 'LK',
'SD' = 'SD',
'SR' = 'SR',
'SJ' = 'SJ',
'SZ' = 'SZ',
'SE' = 'SE',
'CH' = 'CH',
'SY' = 'SY',
'TW' = 'TW',
'TJ' = 'TJ',
'TZ' = 'TZ',
'TH' = 'TH',
'TL' = 'TL',
'TG' = 'TG',
'TK' = 'TK',
'TO' = 'TO',
'TT' = 'TT',
'TN' = 'TN',
'TR' = 'TR',
'TM' = 'TM',
'TC' = 'TC',
'TV' = 'TV',
'UG' = 'UG',
'UA' = 'UA',
'AE' = 'AE',
'GB' = 'GB',
'UM' = 'UM',
'US' = 'US',
'UY' = 'UY',
'UZ' = 'UZ',
'VU' = 'VU',
'VE' = 'VE',
'VN' = 'VN',
'VG' = 'VG',
'VI' = 'VI',
'WF' = 'WF',
'EH' = 'EH',
'YE' = 'YE',
'ZM' = 'ZM',
'ZW' = 'ZW',
}

export enum CreditNoteStatusEnum {
'NEW' = 'NEW',
'SYNCED' = 'SYNCED',
'FAILED' = 'FAILED',
}

export enum CreditNoteVariableSymbolSourceEnum {
'TICKET_CODE' = 'TICKET_CODE',
'ORDER_CODE' = 'ORDER_CODE',
'ORDER_REMOTE_ID' = 'ORDER_REMOTE_ID',
}

export enum CurrencyEnum {
'AUD' = 'AUD',
'BGN' = 'BGN',
'CAD' = 'CAD',
'CHF' = 'CHF',
'CZK' = 'CZK',
'DKK' = 'DKK',
'EUR' = 'EUR',
'GBP' = 'GBP',
'HRK' = 'HRK',
'HUF' = 'HUF',
'ILS' = 'ILS',
'JPY' = 'JPY',
'MXN' = 'MXN',
'NOK' = 'NOK',
'PLN' = 'PLN',
'RON' = 'RON',
'SEK' = 'SEK',
'SGD' = 'SGD',
'THB' = 'THB',
'UAH' = 'UAH',
'USD' = 'USD',
}

export enum CustomFieldTypeEnum {
'BANK_ACCOUNT' = 'BANK_ACCOUNT',
'CHAR' = 'CHAR',
'DATE' = 'DATE',
'MULTILINE' = 'MULTILINE',
'NUMERIC' = 'NUMERIC',
'BOOL' = 'BOOL',
'SELECT' = 'SELECT',
'SELECTMULTI' = 'SELECTMULTI',
'URL' = 'URL',
'FILE' = 'FILE',
'CZECH_BANK_ACCOUNT' = 'CZECH_BANK_ACCOUNT',
'IBAN' = 'IBAN',
}

export enum CustomRefundExportFieldsEnum {
'RECIPIENT_NAME' = 'recipient_name',
'TICKET__CODE' = 'ticket__code',
'VALUE' = 'value',
'CURRENCY' = 'currency',
'VALID_UNTIL' = 'valid_until',
'MESSAGE' = 'message',
'TICKET__TYPE__NAME' = 'ticket__type__name',
'TICKET__BOUND_ORDER__CODE' = 'ticket__bound_order__code',
'TICKET__BOUND_ORDER__CUSTOMER_EMAIL' = 'ticket__bound_order__customer_email',
'TICKET__BOUND_ORDER__CUSTOMER_PHONE' = 'ticket__bound_order__customer_phone',
'TICKET__BOUND_ORDER__TRACKING_NUMBER' = 'ticket__bound_order__tracking_number',
'ANNOTATED_BANK_ACCOUNT' = 'annotated_bank_account',
}

export enum CustomerAddressTypeEnum {
'BILLING' = 'billing',
'SHIPPING' = 'shipping',
}

export enum CustomerCdpMetadataStatusEnum {
'DISABLED' = 'DISABLED',
'BUILDING' = 'BUILDING',
'READY' = 'READY',
}

export enum CustomerLifecycleStageEnum {
'NEW' = 'new',
'DORMANT' = 'dormant',
'AT_RISK' = 'at_risk',
'LOYAL' = 'loyal',
'ACTIVE' = 'active',
'ONE_TIME' = 'one_time',
'UNDETERMINED' = 'undetermined',
}

export enum CustomerRatingEnum {
'VALUE_0' = 0,
'VALUE_1' = 1,
'VALUE_2' = 2,
}

export enum CustomerRiskLevelEnum {
'HIGH' = 'high',
'MEDIUM' = 'medium',
'NONE' = 'none',
}

export enum CustomerSegmentColorEnum {
'GRAY' = 'gray',
'RED' = 'red',
'ORANGE' = 'orange',
'AMBER' = 'amber',
'GREEN' = 'green',
'TEAL' = 'teal',
'BLUE' = 'blue',
'INDIGO' = 'indigo',
'PURPLE' = 'purple',
'PINK' = 'pink',
}

export enum CustomerSegmentEnum {
'FRAGILE_FIRST' = 'fragile_first',
'FADING_REGULAR' = 'fading_regular',
'VIP' = 'vip',
'SERIAL_RETURNER' = 'serial_returner',
'LOYAL_AMBASSADOR' = 'loyal_ambassador',
'NEW_RISING' = 'new_rising',
'STANDARD' = 'standard',
}

export enum CustomerSegmentFieldEnum {
'LIFECYCLE_STAGE' = 'lifecycle_stage',
'RISK_LEVEL' = 'risk_level',
'RETURN_RATE' = 'return_rate',
'ORDERS_COUNT' = 'orders_count',
'TOTAL_ORDER_VALUE' = 'total_order_value',
'RETURNS_COUNT' = 'returns_count',
'CLAIMS_COUNT' = 'claims_count',
'TICKETS_COUNT' = 'tickets_count',
'OPEN_TICKETS_COUNT' = 'open_tickets_count',
'DAYS_SINCE_LAST_ORDER' = 'days_since_last_order',
'DAYS_SINCE_FIRST_ORDER' = 'days_since_first_order',
'TAG' = 'tag',
}

export enum CustomerSegmentMatchEnum {
'AND' = 'AND',
'OR' = 'OR',
}

export enum CustomerSegmentOperatorEnum {
'EQ' = 'eq',
'NE' = 'ne',
'GT' = 'gt',
'LT' = 'lt',
'GTE' = 'gte',
'LTE' = 'lte',
}

export enum CustomerSegmentValueTypeEnum {
'CHOICE' = 'choice',
'INTEGER' = 'integer',
'DECIMAL' = 'decimal',
'TAG' = 'tag',
}

export enum CustomerTimelineItemTypeEnum {
'ORDER' = 'order',
'TICKET' = 'ticket',
'MESSAGE' = 'message',
'NOTE' = 'note',
}

export enum DataRetentionPolicyEnum {
'PRIVATE_DATA' = 'private_data',
'ALL_DATA' = 'all_data',
}

export enum DirectionEnum {
'IN' = 'in',
'OUT' = 'out',
}

export enum DocumentsStatusEnum {
'NOT_REQUIRED' = 'NOT_REQUIRED',
'PENDING' = 'PENDING',
'SYNCING' = 'SYNCING',
'FAILED' = 'FAILED',
'DONE' = 'DONE',
}

export enum DropOffBranchShippingProvidersEnum {
'ZASILKOVNA' = 'ZASILKOVNA',
'MY_GLS_DROPOFF' = 'MY_GLS_DROPOFF',
'DPD_DROPOFF' = 'DPD_DROPOFF',
'RETINO_PPL' = 'RETINO_PPL',
'CUSTOMER_RETINO_PPL' = 'CUSTOMER_RETINO_PPL',
'CUSTOMER_RETINO_GLS_DROPOFF' = 'CUSTOMER_RETINO_GLS_DROPOFF',
'LIFTAGO_RETINO_PPL' = 'LIFTAGO_RETINO_PPL',
'GLS_DROPOFF_PL' = 'GLS_DROPOFF_PL',
'RETURN_CONNECT' = 'RETURN_CONNECT',
'DHL_DROPOFF' = 'DHL_DROPOFF',
}

export enum EqualityEnum {
'EQUALS_TO' = 'EQUALS_TO',
'NOT_EQUALS_TO' = 'NOT_EQUALS_TO',
'GREATER_THAN' = 'GREATER_THAN',
'LESS_THAN' = 'LESS_THAN',
'GREATER_THAN_OR_EQUAL_TO' = 'GREATER_THAN_OR_EQUAL_TO',
'LESS_THAN_OR_EQUAL_TO' = 'LESS_THAN_OR_EQUAL_TO',
'EARLIER_THAN' = 'EARLIER_THAN',
'NOT_EARLIER_THAN' = 'NOT_EARLIER_THAN',
'EMPTY_FIELD' = 'EMPTY_FIELD',
}

export enum EventEnum {
'TICKET_CREATED' = 'ticket.created',
'TICKET_UPDATED' = 'ticket.updated',
'TICKET_PRODUCT_CREATED' = 'ticket.product.created',
'TICKET_PRODUCT_UPDATED' = 'ticket.product.updated',
'TICKET_SHIPPING_CREATED' = 'ticket.shipping.created',
'TICKET_SHIPPING_UPDATED' = 'ticket.shipping.updated',
'TICKET_REFUND_CREATED' = 'ticket.refund.created',
'TICKET_REFUND_UPDATED' = 'ticket.refund.updated',
'RETINO_CREDIT_NOTE_CREATED' = 'retino_credit_note.created',
'RETINO_REFUND_CREATED' = 'retino_refund.created',
'SHIPPING_ORDERED' = 'shipping.ordered',
}

export enum EventsEnum {
'TICKET_CREATED' = 'ticket.created',
'TICKET_UPDATED' = 'ticket.updated',
'TICKET_PRODUCT_CREATED' = 'ticket.product.created',
'TICKET_PRODUCT_UPDATED' = 'ticket.product.updated',
'TICKET_SHIPPING_CREATED' = 'ticket.shipping.created',
'TICKET_SHIPPING_UPDATED' = 'ticket.shipping.updated',
'TICKET_REFUND_CREATED' = 'ticket.refund.created',
'TICKET_REFUND_UPDATED' = 'ticket.refund.updated',
'RETINO_CREDIT_NOTE_CREATED' = 'retino_credit_note.created',
'RETINO_REFUND_CREATED' = 'retino_refund.created',
'SHIPPING_ORDERED' = 'shipping.ordered',
}

export enum ExchangeOrderStatusEnum {
'DRAFT' = 'DRAFT',
'CONFIRMED' = 'CONFIRMED',
'AWAITING_DOCUMENTS' = 'AWAITING_DOCUMENTS',
'AWAITING_PAYMENT' = 'AWAITING_PAYMENT',
'COMPLETED' = 'COMPLETED',
'REJECTED' = 'REJECTED',
'EXPIRED' = 'EXPIRED',
}

export enum ExclusionEnum {
'NO_EXCHANGE' = 'NO_EXCHANGE',
}

export enum ExternalStatusEnum {
'STATUS_ORDERED' = 'STATUS_ORDERED',
'STATUS_IN_TRANSIT' = 'STATUS_IN_TRANSIT',
'STATUS_DELIVERED' = 'STATUS_DELIVERED',
'STATUS_UNDELIVERED' = 'STATUS_UNDELIVERED',
'STATUS_CANCELED' = 'STATUS_CANCELED',
'STATUS_UNKNOWN' = 'STATUS_UNKNOWN',
}

export enum FeaturesEnum {
'REFUNDS' = 'refunds',
'DOCUMENTS' = 'documents',
'CREDIT_NOTES' = 'credit_notes',
'AUTOMATION' = 'automation',
'SHIPPING' = 'shipping',
'TAGS' = 'tags',
'CUSTOM_FIELDS' = 'custom_fields',
'VIEWS' = 'views',
'TICKET_TYPES' = 'ticket_types',
'PROCESSES' = 'processes',
'CANNED_REPLIES' = 'canned_replies',
'EMAILING' = 'emailing',
'PORTAL_EDIT' = 'portal_edit',
'MARKETPLACE' = 'marketplace',
'API_ACCESS' = 'api_access',
'WEBHOOKS' = 'webhooks',
'TICKET_CREATE' = 'ticket_create',
'USER_SIGNATURES' = 'user_signatures',
'PRODUCTS_PAGE' = 'products_page',
'ACTIVITIES' = 'activities',
'STATS' = 'stats',
'CDP' = 'cdp',
'EXCHANGES' = 'exchanges',
'FLOW' = 'flow',
'CUSTOM_ROLES' = 'custom_roles',
'MCP' = 'mcp',
'TRACKING_TRACKNTRACE' = 'tracking_trackntrace',
'TRACKING_EMAILING' = 'tracking_emailing',
'TRACKING_AUTOMATION' = 'tracking_automation',
'TRACKING_ANALYTICS' = 'tracking_analytics',
'TRACKING_COST_ANALYSIS' = 'tracking_cost_analysis',
}

export enum HistoryItemTypeEnum {
'ACTIVITY' = 'ACTIVITY',
'CREDIT_NOTE' = 'CREDIT_NOTE',
'DOCUMENT' = 'DOCUMENT',
'EXCHANGE_ORDER' = 'EXCHANGE_ORDER',
'INTERNAL_NOTE' = 'INTERNAL_NOTE',
'MESSAGE' = 'MESSAGE',
'RATING_COMMENT' = 'RATING_COMMENT',
'REFUND_OPTION' = 'REFUND_OPTION',
'REFUND_REQUEST' = 'REFUND_REQUEST',
'RETINO_SHIPPING' = 'RETINO_SHIPPING',
'SHIPPING_REQUEST' = 'SHIPPING_REQUEST',
'SMS_MESSAGE' = 'SMS_MESSAGE',
'SYSTEM' = 'SYSTEM',
'TRANSPORT' = 'TRANSPORT',
'VOUCHER' = 'VOUCHER',
}

export enum InputRadiusEnum {
'NONE' = 'none',
'SM' = 'sm',
'MD' = 'md',
'LG' = 'lg',
'FULL' = 'full',
}

export enum InstalledPluginStatusEnum {
'NEW' = 'NEW',
'SETUP_PROVIDER' = 'SETUP_PROVIDER',
'ACTIVE' = 'ACTIVE',
'DISABLED' = 'DISABLED',
}

export enum InternalSlugEnum {
'TYPE_RETURN' = 'TYPE_RETURN',
'TYPE_WARRANTY_CLAIM' = 'TYPE_WARRANTY_CLAIM',
'TYPE_SUPPLIER_COMPLAINT' = 'TYPE_SUPPLIER_COMPLAINT',
}

export enum InvoiceTypeEnum {
'PROFORMA_INVOICE' = 'PROFORMA_INVOICE',
'ISSUED_INVOICE' = 'ISSUED_INVOICE',
'ISSUED_CREDIT_NOTICE' = 'ISSUED_CREDIT_NOTICE',
}

export enum IssueTypeEnum {
'NOT_PICKED_UP' = 'NOT_PICKED_UP',
'DRIVER_NOT_ASSIGNED' = 'DRIVER_NOT_ASSIGNED',
'IDLE_PACKAGE' = 'IDLE_PACKAGE',
'PICKUP_DATE_CHANGED' = 'PICKUP_DATE_CHANGED',
}

export enum ItemTypeEnum {
'VALUE_1' = 1,
'VALUE_2' = 2,
'VALUE_3' = 3,
'VALUE_4' = 4,
'VALUE_5' = 5,
'VALUE_6' = 6,
}

export enum LabelTypeEnum {
'PRINT_LABEL' = 'PRINT_LABEL',
'QR_CODE' = 'QR_CODE',
'DROP_OFF_CODE' = 'DROP_OFF_CODE',
}

export enum LabelTypesEnum {
'PRINT_LABEL' = 'PRINT_LABEL',
'QR_CODE' = 'QR_CODE',
'DROP_OFF_CODE' = 'DROP_OFF_CODE',
}

export enum LanguageEnum {
'EN' = 'en',
'DE' = 'de',
'DE-AT' = 'de-at',
'DE-CH' = 'de-ch',
'CS' = 'cs',
'SK' = 'sk',
'PL' = 'pl',
'HU' = 'hu',
'RO' = 'ro',
'ES' = 'es',
'IT' = 'it',
'IT-CH' = 'it-ch',
'FR' = 'fr',
'FR-CH' = 'fr-ch',
'FR-BE' = 'fr-be',
'HR' = 'hr',
'BG' = 'bg',
'SL' = 'sl',
'EL' = 'el',
'NL' = 'nl',
'NL-BE' = 'nl-be',
'NB' = 'nb',
'LV' = 'lv',
'LT' = 'lt',
'ET' = 'et',
'DA' = 'da',
'SV' = 'sv',
'FI' = 'fi',
'PT' = 'pt',
'UK' = 'uk',
'SR' = 'sr',
}

export enum MessageListTypeEnum {
'AGENT_MESSAGE' = 'AGENT_MESSAGE',
'CUSTOMER_MESSAGE' = 'CUSTOMER_MESSAGE',
'OTHERS_MESSAGE' = 'OTHERS_MESSAGE',
'EMAIL' = 'EMAIL',
'SMS' = 'SMS',
}

export enum NotificationTypeEnum {
'TICKET_MESSAGE_ADDED_BY_CUSTOMER' = 'TICKET_MESSAGE_ADDED_BY_CUSTOMER',
'TICKET_MESSAGE_UNDELIVERED' = 'TICKET_MESSAGE_UNDELIVERED',
'TICKET_CREATED_BY_CUSTOMER' = 'TICKET_CREATED_BY_CUSTOMER',
'TICKET_UPCOMING_DATE' = 'TICKET_UPCOMING_DATE',
'TICKET_ASSIGNED' = 'TICKET_ASSIGNED',
'TICKET_INTERNAL_NOTE_MENTION' = 'TICKET_INTERNAL_NOTE_MENTION',
'TICKET_RATED' = 'TICKET_RATED',
'ACTIVITY_DEADLINE_EXPIRES' = 'ACTIVITY_DEADLINE_EXPIRES',
'ACTIVITY_CREATED' = 'ACTIVITY_CREATED',
}

export enum PaymentMethodEnum {
'TRANSFER' = 'TRANSFER',
'CARD' = 'CARD',
}

export enum PhonePrefixEnum {
'+420' = '+420',
'+421' = '+421',
}

export enum PlatformEnum {
'SHOPTET' = 'SHOPTET',
'UPGATES' = 'UPGATES',
'SHOPIFY' = 'SHOPIFY',
'PRESTASHOP' = 'PRESTASHOP',
'NETDIRECT' = 'NETDIRECT',
'WOOCOMMERCE' = 'WOOCOMMERCE',
'MAGENTO_2' = 'MAGENTO_2',
'SHOPSYS' = 'SHOPSYS',
'SIMPLIA' = 'SIMPLIA',
'SHOPRENTER' = 'SHOPRENTER',
'BYZNYSWEB' = 'BYZNYSWEB',
'IDOSELL' = 'IDOSELL',
'CUSTOM' = 'CUSTOM',
'MULTIPLATFORM' = 'MULTIPLATFORM',
}

export enum ProductCustomFieldTypeEnum {
'CHAR' = 'CHAR',
'MULTILINE' = 'MULTILINE',
'DATE' = 'DATE',
'SELECT' = 'SELECT',
'FILE' = 'FILE',
'LINK' = 'LINK',
}

export enum ProductEnum {
'MANAGER' = 'MANAGER',
'TRACKING' = 'TRACKING',
}

export enum ProductFieldEnum {
'MANUFACTURER' = 'manufacturer',
'CATEGORY' = 'category',
'VARIANT' = 'variant',
'PRODUCT_ID' = 'product_id',
'EAN' = 'ean',
'SERIAL' = 'serial',
}

export enum QrCodeRefundVariableSymbolSourceEnum {
'TICKET_CODE' = 'TICKET_CODE',
'ORDER_CODE' = 'ORDER_CODE',
'CREDIT_NOTE_VARIABLE_SYMBOL' = 'CREDIT_NOTE_VARIABLE_SYMBOL',
}

export enum RefundAccountCurrencyEnum {
'CZK' = 'CZK',
'EUR' = 'EUR',
'HUF' = 'HUF',
'USD' = 'USD',
'GBP' = 'GBP',
'CHF' = 'CHF',
'JPY' = 'JPY',
'CAD' = 'CAD',
'AUD' = 'AUD',
'PLN' = 'PLN',
'RON' = 'RON',
'NOK' = 'NOK',
'SEK' = 'SEK',
}

export enum RefundBatchStatusEnum {
'UNPROCESSED' = 'unprocessed',
'PROCESSED' = 'processed',
'FAILED' = 'failed',
'RETRYING' = 'retrying',
}

export enum RefundClientTypeEnum {
'ABO' = 'ABO',
'FIO_ABO' = 'FIO_ABO',
'FIO_PAIN' = 'FIO_PAIN',
'FIO_FOREIGN' = 'FIO_FOREIGN',
'PAIN' = 'PAIN',
'HCT_PAIN' = 'HCT_PAIN',
'RB_HU_REX' = 'RB_HU_REX',
'ING_PLI' = 'ING_PLI',
'RB_RO_XLSX' = 'RB_RO_XLSX',
'CUSTOM' = 'CUSTOM',
'WEBHOOK' = 'WEBHOOK',
}

export enum RefundOptionTypeEnum {
'TO_BANK_ACCOUNT' = 'TO_BANK_ACCOUNT',
'VOUCHER' = 'VOUCHER',
'CUSTOM' = 'CUSTOM',
'WEBHOOK' = 'WEBHOOK',
}

export enum ResultTypeEnum {
'TICKETS' = 'TICKETS',
'ACTIVITIES' = 'ACTIVITIES',
'RETINO_SHIPPING' = 'RETINO_SHIPPING',
'TICKET_PRODUCTS' = 'TICKET_PRODUCTS',
'CUSTOMERS' = 'CUSTOMERS',
'TRACKED_SHIPPING' = 'TRACKED_SHIPPING',
}

export enum RunStatusEnum {
'PENDING' = 'pending',
'RUNNING' = 'running',
'WAITING' = 'waiting',
'DELAYED' = 'delayed',
'COMPLETED' = 'completed',
'FAILED' = 'failed',
}

export enum SectionNameEnum {
'PRODUCTS' = 'PRODUCTS',
'INFO' = 'INFO',
'HISTORY' = 'HISTORY',
'CUSTOMER' = 'CUSTOMER',
'ORDER_ITEMS' = 'ORDER_ITEMS',
}

export enum SelectedRefundOptionStatusEnum {
'WAITING' = 'WAITING',
'ACCEPTED' = 'ACCEPTED',
'DENIED' = 'DENIED',
}

export enum SettingDealQualificationTicketCountEstimateEnum {
'VALUE_21' = 21,
'VALUE_22' = 22,
'VALUE_23' = 23,
'VALUE_24' = 24,
'VALUE_25' = 25,
}

export enum ShippingListBulkActionActionEnum {
'CONFIRM' = 'confirm',
'DECLINE' = 'decline',
}

export enum ShippingPriceEnum {
'BEFOREDISCOUNT' = 'beforeDiscount',
'CART' = 'cart',
'FREE' = 'free',
}

export enum ShippingProviderConfigSubmitTypeEnum {
'DROP_OFF' = 'DROP_OFF',
'PICKUP' = 'PICKUP',
'FREIGHT' = 'FREIGHT',
'CUSTOM' = 'CUSTOM',
'IN_PERSON' = 'IN_PERSON',
}

export enum ShippingProvidersEnum {
'CUSTOM' = 'CUSTOM',
'DHL24_PICKUP' = 'DHL24_PICKUP',
'DHL24_DROP_OFF' = 'DHL24_DROP_OFF',
'DHL_FREIGHT_PICKUP' = 'DHL_FREIGHT_PICKUP',
'DHL_INTERNATIONAL_DROPOFF' = 'DHL_INTERNATIONAL_DROPOFF',
'DPD_BELGIUM_DROPOFF' = 'DPD_BELGIUM_DROPOFF',
'DPD_GEO_API_DROPOFF' = 'DPD_GEO_API_DROPOFF',
'DPD_GEO_API_PICKUP' = 'DPD_GEO_API_PICKUP',
'DPD_HU_DROPOFF' = 'DPD_HU_DROPOFF',
'DPD_HU_PICKUP' = 'DPD_HU_PICKUP',
'DPD_REG_PRIJEMCE_PICKUP' = 'DPD_REG_PRIJEMCE_PICKUP',
'DPD_REG_PRIJEMCE_DROPOFF' = 'DPD_REG_PRIJEMCE_DROPOFF',
'DPD_SK_PICKUP' = 'DPD_SK_PICKUP',
'DPD_SK_DROPOFF' = 'DPD_SK_DROPOFF',
'FOXPOST_RETURNS' = 'FOXPOST_RETURNS',
'GEIS_PICKUP' = 'GEIS_PICKUP',
'GLS_PICKUP' = 'GLS_PICKUP',
'GLS_ISRS' = 'GLS_ISRS',
'GLS_POLAND_API_DROPOFF' = 'GLS_POLAND_API_DROPOFF',
'IN_PERSON' = 'IN_PERSON',
'INPOST_DROP_OFF' = 'INPOST_DROP_OFF',
'INPOST_PICKUP' = 'INPOST_PICKUP',
'LIFTAGO' = 'LIFTAGO',
'MY_GLS_DROP_OFF_CZ' = 'MY_GLS_DROP_OFF_CZ',
'MY_GLS_DROP_OFF_SK' = 'MY_GLS_DROP_OFF_SK',
'MY_GLS_DROP_OFF_HU' = 'MY_GLS_DROP_OFF_HU',
'MY_GLS_BOX_CZ' = 'MY_GLS_BOX_CZ',
'MY_GLS_PICKUP_CZ' = 'MY_GLS_PICKUP_CZ',
'MY_GLS_PICKUP_SK' = 'MY_GLS_PICKUP_SK',
'MY_GLS_PICKUP_HU' = 'MY_GLS_PICKUP_HU',
'MY_GLS_PICKUP_SI' = 'MY_GLS_PICKUP_SI',
'MY_GLS_PICKUP_HR' = 'MY_GLS_PICKUP_HR',
'MY_PPL_PICKUP' = 'MY_PPL_PICKUP',
'PACKETA_CLAIM_ASSISTANT' = 'PACKETA_CLAIM_ASSISTANT',
'MY_PPL_CPL_DROPOFF' = 'MY_PPL_CPL_DROPOFF',
'MY_PPL_CPL_PICKUP' = 'MY_PPL_CPL_PICKUP',
'PPL_RETURN_CONNECT_DROPOFF' = 'PPL_RETURN_CONNECT_DROPOFF',
'PPL_RETURN_CONNECT_PICKUP' = 'PPL_RETURN_CONNECT_PICKUP',
'RABEN_FREIGHT' = 'RABEN_FREIGHT',
'SPS_DROPOFF' = 'SPS_DROPOFF',
'UPS_PICKUP' = 'UPS_PICKUP',
}

export enum ShippingProvidersListResponseSubmitTypeEnum {
'PICKUP' = 'PICKUP',
'DROP_OFF' = 'DROP_OFF',
'OTHER' = 'OTHER',
}

export enum ShippingStatusEnum {
'CONFIRMATION_REQUIRED' = 'CONFIRMATION_REQUIRED',
'WAITING' = 'WAITING',
'SYNCING' = 'SYNCING',
'FINISHED' = 'FINISHED',
'REFUNDED' = 'REFUNDED',
'CANCELED' = 'CANCELED',
'DECLINED' = 'DECLINED',
'FAILURE' = 'FAILURE',
'VOIDED' = 'VOIDED',
}

export enum ShoptetVoucherDiscountTypeEnum {
'FIXED' = 'fixed',
'PERCENTUAL' = 'percentual',
}

export enum StatusToneEnum {
'POSITIVE' = 'positive',
'NEGATIVE' = 'negative',
'NEUTRAL' = 'neutral',
}

export enum StepStatusEnum {
'COMPLETED' = 'completed',
'FAILED' = 'failed',
}

export enum TicketFieldEnum {
'ORDER_ID' = 'order_id',
'CUSTOMER_EMAIL' = 'customer_email',
'CUSTOMER_NAME' = 'customer_name',
'CUSTOMER_PHONE' = 'customer_phone',
}

export enum TicketTypeInternalSlugEnum {
'TYPE_RETURN' = 'TYPE_RETURN',
'TYPE_WARRANTY_CLAIM' = 'TYPE_WARRANTY_CLAIM',
'TYPE_SUPPLIER_COMPLAINT' = 'TYPE_SUPPLIER_COMPLAINT',
}

export enum TransportProviderEnum {
'ZASILKOVNA' = 'ZASILKOVNA',
'GLS' = 'GLS',
'MY_GLS' = 'MY_GLS',
'MY_GLS_DROPOFF' = 'MY_GLS_DROPOFF',
'PPL' = 'PPL',
'DPD_PICKUP' = 'DPD_PICKUP',
'DPD_DROPOFF' = 'DPD_DROPOFF',
'RETINO_PPL' = 'RETINO_PPL',
'CUSTOMER_RETINO_PPL' = 'CUSTOMER_RETINO_PPL',
'CUSTOMER_RETINO_GLS_PICKUP' = 'CUSTOMER_RETINO_GLS_PICKUP',
'CUSTOMER_RETINO_GLS_DROPOFF' = 'CUSTOMER_RETINO_GLS_DROPOFF',
'LIFTAGO' = 'LIFTAGO',
'LIFTAGO_RETINO_PPL' = 'LIFTAGO_RETINO_PPL',
'GEIS' = 'GEIS',
'GLS_DROPOFF_PL' = 'GLS_DROPOFF_PL',
'CUSTOMER_RETINO_GLS_PICKUP_SK' = 'CUSTOMER_RETINO_GLS_PICKUP_SK',
'CUSTOMER_RETINO_GLS_PICKUP_HU' = 'CUSTOMER_RETINO_GLS_PICKUP_HU',
'RETURN_CONNECT' = 'RETURN_CONNECT',
'DHL_FREIGHT' = 'DHL_FREIGHT',
'DHL_DROPOFF' = 'DHL_DROPOFF',
'CUSTOM_OTHER_PROVIDER' = 'CUSTOM_OTHER_PROVIDER',
}

export enum TransportStatusEnum {
'STATUS_PENDING_CONFIRMATION' = 'STATUS_PENDING_CONFIRMATION',
'STATUS_INIT' = 'STATUS_INIT',
'STATUS_ACCEPTED' = 'STATUS_ACCEPTED',
'STATUS_SUBMITTED' = 'STATUS_SUBMITTED',
'STATUS_TRANSPORT' = 'STATUS_TRANSPORT',
'STATUS_DELIVERED' = 'STATUS_DELIVERED',
'STATUS_UNDELIVERED' = 'STATUS_UNDELIVERED',
'STATUS_CANCELED' = 'STATUS_CANCELED',
'STATUS_WAITING_FOR_ORDERING' = 'STATUS_WAITING_FOR_ORDERING',
'STATUS_REFUNDED' = 'STATUS_REFUNDED',
'STATUS_UNKNOWN' = 'STATUS_UNKNOWN',
}

export enum TriggerConditionTypeEnum {
'STATE' = 'STATE',
'TYPE' = 'TYPE',
'TAG' = 'TAG',
'TICKET_LANGUAGE' = 'TICKET_LANGUAGE',
'TICKET_COUNTRY' = 'TICKET_COUNTRY',
'TICKET_OWNER' = 'TICKET_OWNER',
'TICKET_BOUND_ORDER' = 'TICKET_BOUND_ORDER',
'TICKET_VERIFICATION_STATE' = 'TICKET_VERIFICATION_STATE',
'TICKET_CURRENCY' = 'TICKET_CURRENCY',
'CUSTOM_FIELD' = 'CUSTOM_FIELD',
'PREFERRED_SHIPPING' = 'PREFERRED_SHIPPING',
'NUMBER_OF_PRODUCTS' = 'NUMBER_OF_PRODUCTS',
'SHIPPING_EXTERNAL_STATUS' = 'SHIPPING_EXTERNAL_STATUS',
'ORDER_DATE' = 'ORDER_DATE',
'TICKET_VALUE' = 'TICKET_VALUE',
'ORDER_VALUE' = 'ORDER_VALUE',
}

export enum TriggerLogStateEnum {
'SUCCESS' = 'SUCCESS',
'FAILED' = 'FAILED',
'CAN_RETRY' = 'CAN_RETRY',
}

export enum TriggerTypeEnum {
'TICKET_CREATED_BY_CUSTOMER' = 'TICKET_CREATED_BY_CUSTOMER',
'TICKET_CREATED_BY_AGENT' = 'TICKET_CREATED_BY_AGENT',
'TICKET_STATE_CHANGED' = 'TICKET_STATE_CHANGED',
'TICKET_TAG_ADDED' = 'TICKET_TAG_ADDED',
'TICKET_CLOSED' = 'TICKET_CLOSED',
'TICKET_OWNER_CHANGED' = 'TICKET_OWNER_CHANGED',
'CUSTOMER_SENT_MESSAGE' = 'CUSTOMER_SENT_MESSAGE',
'REFUND_REQUEST_CREATED' = 'REFUND_REQUEST_CREATED',
'ACTIVITY_CREATED' = 'ACTIVITY_CREATED',
'ACTIVITY_DEADLINE_EXPIRED' = 'ACTIVITY_DEADLINE_EXPIRED',
'SHIPPING_STATUS_CHANGED' = 'SHIPPING_STATUS_CHANGED',
}

export enum UsageTypeEnum {
'LICENSED' = 'LICENSED',
'METERED' = 'METERED',
}

export enum UserLanguageEnum {
'EN' = 'en',
'DE' = 'de',
'CS' = 'cs',
'SK' = 'sk',
'PL' = 'pl',
'HU' = 'hu',
'RO' = 'ro',
'ES' = 'es',
'IT' = 'it',
'FR' = 'fr',
'HR' = 'hr',
'BG' = 'bg',
'SL' = 'sl',
'EL' = 'el',
'NL' = 'nl',
'NB' = 'nb',
'LV' = 'lv',
'LT' = 'lt',
'ET' = 'et',
'DA' = 'da',
'SV' = 'sv',
'FI' = 'fi',
'PT' = 'pt',
'UK' = 'uk',
}

export enum VariableSymbolSourceEnum {
'TICKET_CODE' = 'TICKET_CODE',
'ORDER_CODE' = 'ORDER_CODE',
'CREDIT_NOTE_VARIABLE_SYMBOL' = 'CREDIT_NOTE_VARIABLE_SYMBOL',
}

export enum VerificationStateEnum {
'VERIFIED_AUTOMATICALLY' = 'VERIFIED_AUTOMATICALLY',
'VERIFIED_MANUALLY' = 'VERIFIED_MANUALLY',
'UNVERIFIED' = 'UNVERIFIED',
}

export enum WebhookEndpointStatusEnum {
'ENABLED' = 'enabled',
'DISABLED' = 'disabled',
}

export enum WebhookStatusEnum {
'PENDING' = 'pending',
'SUCCESS' = 'success',
'RETRYING' = 'retrying',
'FAILURE' = 'failure',
}

export enum WooCommerceVoucherDiscountTypeEnum {
'FIXED_CART' = 'fixed_cart',
'PERCENT' = 'percent',
'FIXED_PRODUCT' = 'fixed_product',
'PERCENT_PRODUCT' = 'percent_product',
}

export enum ActivitiesListStatusEnum {
'STATUS_CLOSED' = 'STATUS_CLOSED',
'STATUS_OPEN' = 'STATUS_OPEN',
}

export enum ActivitiesListTicketCountryEnum {
'AD' = 'AD',
'AE' = 'AE',
'AF' = 'AF',
'AG' = 'AG',
'AI' = 'AI',
'AL' = 'AL',
'AM' = 'AM',
'AO' = 'AO',
'AQ' = 'AQ',
'AR' = 'AR',
'AS' = 'AS',
'AT' = 'AT',
'AU' = 'AU',
'AW' = 'AW',
'AX' = 'AX',
'AZ' = 'AZ',
'BA' = 'BA',
'BB' = 'BB',
'BD' = 'BD',
'BE' = 'BE',
'BF' = 'BF',
'BG' = 'BG',
'BH' = 'BH',
'BI' = 'BI',
'BJ' = 'BJ',
'BL' = 'BL',
'BM' = 'BM',
'BN' = 'BN',
'BO' = 'BO',
'BQ' = 'BQ',
'BR' = 'BR',
'BS' = 'BS',
'BT' = 'BT',
'BV' = 'BV',
'BW' = 'BW',
'BY' = 'BY',
'BZ' = 'BZ',
'CA' = 'CA',
'CC' = 'CC',
'CD' = 'CD',
'CF' = 'CF',
'CG' = 'CG',
'CH' = 'CH',
'CI' = 'CI',
'CK' = 'CK',
'CL' = 'CL',
'CM' = 'CM',
'CN' = 'CN',
'CO' = 'CO',
'CR' = 'CR',
'CU' = 'CU',
'CV' = 'CV',
'CW' = 'CW',
'CX' = 'CX',
'CY' = 'CY',
'CZ' = 'CZ',
'DE' = 'DE',
'DJ' = 'DJ',
'DK' = 'DK',
'DM' = 'DM',
'DO' = 'DO',
'DZ' = 'DZ',
'EC' = 'EC',
'EE' = 'EE',
'EG' = 'EG',
'EH' = 'EH',
'ER' = 'ER',
'ES' = 'ES',
'ET' = 'ET',
'FI' = 'FI',
'FJ' = 'FJ',
'FK' = 'FK',
'FM' = 'FM',
'FO' = 'FO',
'FR' = 'FR',
'GA' = 'GA',
'GB' = 'GB',
'GD' = 'GD',
'GE' = 'GE',
'GF' = 'GF',
'GG' = 'GG',
'GH' = 'GH',
'GI' = 'GI',
'GL' = 'GL',
'GM' = 'GM',
'GN' = 'GN',
'GP' = 'GP',
'GQ' = 'GQ',
'GR' = 'GR',
'GS' = 'GS',
'GT' = 'GT',
'GU' = 'GU',
'GW' = 'GW',
'GY' = 'GY',
'HK' = 'HK',
'HM' = 'HM',
'HN' = 'HN',
'HR' = 'HR',
'HT' = 'HT',
'HU' = 'HU',
'ID' = 'ID',
'IE' = 'IE',
'IL' = 'IL',
'IM' = 'IM',
'IN' = 'IN',
'IO' = 'IO',
'IQ' = 'IQ',
'IR' = 'IR',
'IS' = 'IS',
'IT' = 'IT',
'JE' = 'JE',
'JM' = 'JM',
'JO' = 'JO',
'JP' = 'JP',
'KE' = 'KE',
'KG' = 'KG',
'KH' = 'KH',
'KI' = 'KI',
'KM' = 'KM',
'KN' = 'KN',
'KP' = 'KP',
'KR' = 'KR',
'KW' = 'KW',
'KY' = 'KY',
'KZ' = 'KZ',
'LA' = 'LA',
'LB' = 'LB',
'LC' = 'LC',
'LI' = 'LI',
'LK' = 'LK',
'LR' = 'LR',
'LS' = 'LS',
'LT' = 'LT',
'LU' = 'LU',
'LV' = 'LV',
'LY' = 'LY',
'MA' = 'MA',
'MC' = 'MC',
'MD' = 'MD',
'ME' = 'ME',
'MF' = 'MF',
'MG' = 'MG',
'MH' = 'MH',
'MK' = 'MK',
'ML' = 'ML',
'MM' = 'MM',
'MN' = 'MN',
'MO' = 'MO',
'MP' = 'MP',
'MQ' = 'MQ',
'MR' = 'MR',
'MS' = 'MS',
'MT' = 'MT',
'MU' = 'MU',
'MV' = 'MV',
'MW' = 'MW',
'MX' = 'MX',
'MY' = 'MY',
'MZ' = 'MZ',
'NA' = 'NA',
'NC' = 'NC',
'NE' = 'NE',
'NF' = 'NF',
'NG' = 'NG',
'NI' = 'NI',
'NL' = 'NL',
'NO' = 'NO',
'NP' = 'NP',
'NR' = 'NR',
'NU' = 'NU',
'NZ' = 'NZ',
'OM' = 'OM',
'PA' = 'PA',
'PE' = 'PE',
'PF' = 'PF',
'PG' = 'PG',
'PH' = 'PH',
'PK' = 'PK',
'PL' = 'PL',
'PM' = 'PM',
'PN' = 'PN',
'PR' = 'PR',
'PS' = 'PS',
'PT' = 'PT',
'PW' = 'PW',
'PY' = 'PY',
'QA' = 'QA',
'RE' = 'RE',
'RO' = 'RO',
'RS' = 'RS',
'RU' = 'RU',
'RW' = 'RW',
'SA' = 'SA',
'SB' = 'SB',
'SC' = 'SC',
'SD' = 'SD',
'SE' = 'SE',
'SG' = 'SG',
'SH' = 'SH',
'SI' = 'SI',
'SJ' = 'SJ',
'SK' = 'SK',
'SL' = 'SL',
'SM' = 'SM',
'SN' = 'SN',
'SO' = 'SO',
'SR' = 'SR',
'SS' = 'SS',
'ST' = 'ST',
'SV' = 'SV',
'SX' = 'SX',
'SY' = 'SY',
'SZ' = 'SZ',
'TC' = 'TC',
'TD' = 'TD',
'TF' = 'TF',
'TG' = 'TG',
'TH' = 'TH',
'TJ' = 'TJ',
'TK' = 'TK',
'TL' = 'TL',
'TM' = 'TM',
'TN' = 'TN',
'TO' = 'TO',
'TR' = 'TR',
'TT' = 'TT',
'TV' = 'TV',
'TW' = 'TW',
'TZ' = 'TZ',
'UA' = 'UA',
'UG' = 'UG',
'UM' = 'UM',
'US' = 'US',
'UY' = 'UY',
'UZ' = 'UZ',
'VA' = 'VA',
'VC' = 'VC',
'VE' = 'VE',
'VG' = 'VG',
'VI' = 'VI',
'VN' = 'VN',
'VU' = 'VU',
'WF' = 'WF',
'WS' = 'WS',
'YE' = 'YE',
'YT' = 'YT',
'ZA' = 'ZA',
'ZM' = 'ZM',
'ZW' = 'ZW',
}

export enum CommunicationListTicketCountryEnum {
'AD' = 'AD',
'AE' = 'AE',
'AF' = 'AF',
'AG' = 'AG',
'AI' = 'AI',
'AL' = 'AL',
'AM' = 'AM',
'AO' = 'AO',
'AQ' = 'AQ',
'AR' = 'AR',
'AS' = 'AS',
'AT' = 'AT',
'AU' = 'AU',
'AW' = 'AW',
'AX' = 'AX',
'AZ' = 'AZ',
'BA' = 'BA',
'BB' = 'BB',
'BD' = 'BD',
'BE' = 'BE',
'BF' = 'BF',
'BG' = 'BG',
'BH' = 'BH',
'BI' = 'BI',
'BJ' = 'BJ',
'BL' = 'BL',
'BM' = 'BM',
'BN' = 'BN',
'BO' = 'BO',
'BQ' = 'BQ',
'BR' = 'BR',
'BS' = 'BS',
'BT' = 'BT',
'BV' = 'BV',
'BW' = 'BW',
'BY' = 'BY',
'BZ' = 'BZ',
'CA' = 'CA',
'CC' = 'CC',
'CD' = 'CD',
'CF' = 'CF',
'CG' = 'CG',
'CH' = 'CH',
'CI' = 'CI',
'CK' = 'CK',
'CL' = 'CL',
'CM' = 'CM',
'CN' = 'CN',
'CO' = 'CO',
'CR' = 'CR',
'CU' = 'CU',
'CV' = 'CV',
'CW' = 'CW',
'CX' = 'CX',
'CY' = 'CY',
'CZ' = 'CZ',
'DE' = 'DE',
'DJ' = 'DJ',
'DK' = 'DK',
'DM' = 'DM',
'DO' = 'DO',
'DZ' = 'DZ',
'EC' = 'EC',
'EE' = 'EE',
'EG' = 'EG',
'EH' = 'EH',
'ER' = 'ER',
'ES' = 'ES',
'ET' = 'ET',
'FI' = 'FI',
'FJ' = 'FJ',
'FK' = 'FK',
'FM' = 'FM',
'FO' = 'FO',
'FR' = 'FR',
'GA' = 'GA',
'GB' = 'GB',
'GD' = 'GD',
'GE' = 'GE',
'GF' = 'GF',
'GG' = 'GG',
'GH' = 'GH',
'GI' = 'GI',
'GL' = 'GL',
'GM' = 'GM',
'GN' = 'GN',
'GP' = 'GP',
'GQ' = 'GQ',
'GR' = 'GR',
'GS' = 'GS',
'GT' = 'GT',
'GU' = 'GU',
'GW' = 'GW',
'GY' = 'GY',
'HK' = 'HK',
'HM' = 'HM',
'HN' = 'HN',
'HR' = 'HR',
'HT' = 'HT',
'HU' = 'HU',
'ID' = 'ID',
'IE' = 'IE',
'IL' = 'IL',
'IM' = 'IM',
'IN' = 'IN',
'IO' = 'IO',
'IQ' = 'IQ',
'IR' = 'IR',
'IS' = 'IS',
'IT' = 'IT',
'JE' = 'JE',
'JM' = 'JM',
'JO' = 'JO',
'JP' = 'JP',
'KE' = 'KE',
'KG' = 'KG',
'KH' = 'KH',
'KI' = 'KI',
'KM' = 'KM',
'KN' = 'KN',
'KP' = 'KP',
'KR' = 'KR',
'KW' = 'KW',
'KY' = 'KY',
'KZ' = 'KZ',
'LA' = 'LA',
'LB' = 'LB',
'LC' = 'LC',
'LI' = 'LI',
'LK' = 'LK',
'LR' = 'LR',
'LS' = 'LS',
'LT' = 'LT',
'LU' = 'LU',
'LV' = 'LV',
'LY' = 'LY',
'MA' = 'MA',
'MC' = 'MC',
'MD' = 'MD',
'ME' = 'ME',
'MF' = 'MF',
'MG' = 'MG',
'MH' = 'MH',
'MK' = 'MK',
'ML' = 'ML',
'MM' = 'MM',
'MN' = 'MN',
'MO' = 'MO',
'MP' = 'MP',
'MQ' = 'MQ',
'MR' = 'MR',
'MS' = 'MS',
'MT' = 'MT',
'MU' = 'MU',
'MV' = 'MV',
'MW' = 'MW',
'MX' = 'MX',
'MY' = 'MY',
'MZ' = 'MZ',
'NA' = 'NA',
'NC' = 'NC',
'NE' = 'NE',
'NF' = 'NF',
'NG' = 'NG',
'NI' = 'NI',
'NL' = 'NL',
'NO' = 'NO',
'NP' = 'NP',
'NR' = 'NR',
'NU' = 'NU',
'NZ' = 'NZ',
'OM' = 'OM',
'PA' = 'PA',
'PE' = 'PE',
'PF' = 'PF',
'PG' = 'PG',
'PH' = 'PH',
'PK' = 'PK',
'PL' = 'PL',
'PM' = 'PM',
'PN' = 'PN',
'PR' = 'PR',
'PS' = 'PS',
'PT' = 'PT',
'PW' = 'PW',
'PY' = 'PY',
'QA' = 'QA',
'RE' = 'RE',
'RO' = 'RO',
'RS' = 'RS',
'RU' = 'RU',
'RW' = 'RW',
'SA' = 'SA',
'SB' = 'SB',
'SC' = 'SC',
'SD' = 'SD',
'SE' = 'SE',
'SG' = 'SG',
'SH' = 'SH',
'SI' = 'SI',
'SJ' = 'SJ',
'SK' = 'SK',
'SL' = 'SL',
'SM' = 'SM',
'SN' = 'SN',
'SO' = 'SO',
'SR' = 'SR',
'SS' = 'SS',
'ST' = 'ST',
'SV' = 'SV',
'SX' = 'SX',
'SY' = 'SY',
'SZ' = 'SZ',
'TC' = 'TC',
'TD' = 'TD',
'TF' = 'TF',
'TG' = 'TG',
'TH' = 'TH',
'TJ' = 'TJ',
'TK' = 'TK',
'TL' = 'TL',
'TM' = 'TM',
'TN' = 'TN',
'TO' = 'TO',
'TR' = 'TR',
'TT' = 'TT',
'TV' = 'TV',
'TW' = 'TW',
'TZ' = 'TZ',
'UA' = 'UA',
'UG' = 'UG',
'UM' = 'UM',
'US' = 'US',
'UY' = 'UY',
'UZ' = 'UZ',
'VA' = 'VA',
'VC' = 'VC',
'VE' = 'VE',
'VG' = 'VG',
'VI' = 'VI',
'VN' = 'VN',
'VU' = 'VU',
'WF' = 'WF',
'WS' = 'WS',
'YE' = 'YE',
'YT' = 'YT',
'ZA' = 'ZA',
'ZM' = 'ZM',
'ZW' = 'ZW',
}

export enum CommunicationListTicketLanguageEnum {
'BG' = 'bg',
'CS' = 'cs',
'DA' = 'da',
'DE' = 'de',
'DE-AT' = 'de-at',
'DE-CH' = 'de-ch',
'EL' = 'el',
'EN' = 'en',
'ES' = 'es',
'ET' = 'et',
'FI' = 'fi',
'FR' = 'fr',
'FR-BE' = 'fr-be',
'FR-CH' = 'fr-ch',
'HR' = 'hr',
'HU' = 'hu',
'IT' = 'it',
'IT-CH' = 'it-ch',
'LT' = 'lt',
'LV' = 'lv',
'NB' = 'nb',
'NL' = 'nl',
'NL-BE' = 'nl-be',
'PL' = 'pl',
'PT' = 'pt',
'RO' = 'ro',
'SK' = 'sk',
'SL' = 'sl',
'SR' = 'sr',
'SV' = 'sv',
'UK' = 'uk',
}

export enum CustomFieldsListTypeEnum {
'BANK_ACCOUNT' = 'BANK_ACCOUNT',
'BOOL' = 'BOOL',
'CHAR' = 'CHAR',
'CZECH_BANK_ACCOUNT' = 'CZECH_BANK_ACCOUNT',
'DATE' = 'DATE',
'FILE' = 'FILE',
'IBAN' = 'IBAN',
'MULTILINE' = 'MULTILINE',
'NUMERIC' = 'NUMERIC',
'SELECT' = 'SELECT',
'SELECTMULTI' = 'SELECTMULTI',
'URL' = 'URL',
}

export enum CustomerSegmentsSystemPutSegmentIdEnum {
'FADING_REGULAR' = 'fading_regular',
'FRAGILE_FIRST' = 'fragile_first',
'LOYAL_AMBASSADOR' = 'loyal_ambassador',
'NEW_RISING' = 'new_rising',
'SERIAL_RETURNER' = 'serial_returner',
'STANDARD' = 'standard',
'VIP' = 'vip',
}

export enum CustomersTimelineRetrieveTypeEnum {
'ALL' = 'all',
'ORDER' = 'order',
'TICKET' = 'ticket',
'MESSAGE' = 'message',
'NOTE' = 'note',
}

export enum FlowAgentInputListOrderingEnum {
'-CREATED_AT' = '-created_at',
'-EXPIRES_AT' = '-expires_at',
'CREATED_AT' = 'created_at',
'EXPIRES_AT' = 'expires_at',
}

export enum FlowAgentInputListStatusEnum {
'CANCELLED' = 'cancelled',
'COMPLETED' = 'completed',
'EXPIRED' = 'expired',
'PENDING' = 'pending',
}

export enum RefundAccountsListCurrencyEnum {
'AUD' = 'AUD',
'CAD' = 'CAD',
'CHF' = 'CHF',
'CZK' = 'CZK',
'EUR' = 'EUR',
'GBP' = 'GBP',
'HUF' = 'HUF',
'JPY' = 'JPY',
'NOK' = 'NOK',
'PLN' = 'PLN',
'RON' = 'RON',
'SEK' = 'SEK',
'USD' = 'USD',
}

export enum RetinoShippingShippingListListShippingProviderEnum {
'CUSTOM' = 'CUSTOM',
'DHL24_DROP_OFF' = 'DHL24_DROP_OFF',
'DHL24_PICKUP' = 'DHL24_PICKUP',
'DHL_FREIGHT_PICKUP' = 'DHL_FREIGHT_PICKUP',
'DHL_INTERNATIONAL_DROPOFF' = 'DHL_INTERNATIONAL_DROPOFF',
'DPD_BELGIUM_DROPOFF' = 'DPD_BELGIUM_DROPOFF',
'DPD_GEO_API_DROPOFF' = 'DPD_GEO_API_DROPOFF',
'DPD_GEO_API_PICKUP' = 'DPD_GEO_API_PICKUP',
'DPD_HU_DROPOFF' = 'DPD_HU_DROPOFF',
'DPD_HU_PICKUP' = 'DPD_HU_PICKUP',
'DPD_REG_PRIJEMCE_DROPOFF' = 'DPD_REG_PRIJEMCE_DROPOFF',
'DPD_REG_PRIJEMCE_PICKUP' = 'DPD_REG_PRIJEMCE_PICKUP',
'DPD_SK_DROPOFF' = 'DPD_SK_DROPOFF',
'DPD_SK_PICKUP' = 'DPD_SK_PICKUP',
'FOXPOST_RETURNS' = 'FOXPOST_RETURNS',
'GEIS_PICKUP' = 'GEIS_PICKUP',
'GLS_ISRS' = 'GLS_ISRS',
'GLS_PICKUP' = 'GLS_PICKUP',
'GLS_POLAND_API_DROPOFF' = 'GLS_POLAND_API_DROPOFF',
'INPOST_DROP_OFF' = 'INPOST_DROP_OFF',
'INPOST_PICKUP' = 'INPOST_PICKUP',
'IN_PERSON' = 'IN_PERSON',
'LIFTAGO' = 'LIFTAGO',
'MY_GLS_BOX_CZ' = 'MY_GLS_BOX_CZ',
'MY_GLS_DROP_OFF_CZ' = 'MY_GLS_DROP_OFF_CZ',
'MY_GLS_DROP_OFF_HU' = 'MY_GLS_DROP_OFF_HU',
'MY_GLS_DROP_OFF_SK' = 'MY_GLS_DROP_OFF_SK',
'MY_GLS_PICKUP_CZ' = 'MY_GLS_PICKUP_CZ',
'MY_GLS_PICKUP_HR' = 'MY_GLS_PICKUP_HR',
'MY_GLS_PICKUP_HU' = 'MY_GLS_PICKUP_HU',
'MY_GLS_PICKUP_SI' = 'MY_GLS_PICKUP_SI',
'MY_GLS_PICKUP_SK' = 'MY_GLS_PICKUP_SK',
'MY_PPL_CPL_DROPOFF' = 'MY_PPL_CPL_DROPOFF',
'MY_PPL_CPL_PICKUP' = 'MY_PPL_CPL_PICKUP',
'MY_PPL_PICKUP' = 'MY_PPL_PICKUP',
'PACKETA_CLAIM_ASSISTANT' = 'PACKETA_CLAIM_ASSISTANT',
'PPL_RETURN_CONNECT_DROPOFF' = 'PPL_RETURN_CONNECT_DROPOFF',
'PPL_RETURN_CONNECT_PICKUP' = 'PPL_RETURN_CONNECT_PICKUP',
'RABEN_FREIGHT' = 'RABEN_FREIGHT',
'SPS_DROPOFF' = 'SPS_DROPOFF',
'UPS_PICKUP' = 'UPS_PICKUP',
}

export enum RetinoShippingShippingListListTicketCountryEnum {
'AD' = 'AD',
'AE' = 'AE',
'AF' = 'AF',
'AG' = 'AG',
'AI' = 'AI',
'AL' = 'AL',
'AM' = 'AM',
'AO' = 'AO',
'AQ' = 'AQ',
'AR' = 'AR',
'AS' = 'AS',
'AT' = 'AT',
'AU' = 'AU',
'AW' = 'AW',
'AX' = 'AX',
'AZ' = 'AZ',
'BA' = 'BA',
'BB' = 'BB',
'BD' = 'BD',
'BE' = 'BE',
'BF' = 'BF',
'BG' = 'BG',
'BH' = 'BH',
'BI' = 'BI',
'BJ' = 'BJ',
'BL' = 'BL',
'BM' = 'BM',
'BN' = 'BN',
'BO' = 'BO',
'BQ' = 'BQ',
'BR' = 'BR',
'BS' = 'BS',
'BT' = 'BT',
'BV' = 'BV',
'BW' = 'BW',
'BY' = 'BY',
'BZ' = 'BZ',
'CA' = 'CA',
'CC' = 'CC',
'CD' = 'CD',
'CF' = 'CF',
'CG' = 'CG',
'CH' = 'CH',
'CI' = 'CI',
'CK' = 'CK',
'CL' = 'CL',
'CM' = 'CM',
'CN' = 'CN',
'CO' = 'CO',
'CR' = 'CR',
'CU' = 'CU',
'CV' = 'CV',
'CW' = 'CW',
'CX' = 'CX',
'CY' = 'CY',
'CZ' = 'CZ',
'DE' = 'DE',
'DJ' = 'DJ',
'DK' = 'DK',
'DM' = 'DM',
'DO' = 'DO',
'DZ' = 'DZ',
'EC' = 'EC',
'EE' = 'EE',
'EG' = 'EG',
'EH' = 'EH',
'ER' = 'ER',
'ES' = 'ES',
'ET' = 'ET',
'FI' = 'FI',
'FJ' = 'FJ',
'FK' = 'FK',
'FM' = 'FM',
'FO' = 'FO',
'FR' = 'FR',
'GA' = 'GA',
'GB' = 'GB',
'GD' = 'GD',
'GE' = 'GE',
'GF' = 'GF',
'GG' = 'GG',
'GH' = 'GH',
'GI' = 'GI',
'GL' = 'GL',
'GM' = 'GM',
'GN' = 'GN',
'GP' = 'GP',
'GQ' = 'GQ',
'GR' = 'GR',
'GS' = 'GS',
'GT' = 'GT',
'GU' = 'GU',
'GW' = 'GW',
'GY' = 'GY',
'HK' = 'HK',
'HM' = 'HM',
'HN' = 'HN',
'HR' = 'HR',
'HT' = 'HT',
'HU' = 'HU',
'ID' = 'ID',
'IE' = 'IE',
'IL' = 'IL',
'IM' = 'IM',
'IN' = 'IN',
'IO' = 'IO',
'IQ' = 'IQ',
'IR' = 'IR',
'IS' = 'IS',
'IT' = 'IT',
'JE' = 'JE',
'JM' = 'JM',
'JO' = 'JO',
'JP' = 'JP',
'KE' = 'KE',
'KG' = 'KG',
'KH' = 'KH',
'KI' = 'KI',
'KM' = 'KM',
'KN' = 'KN',
'KP' = 'KP',
'KR' = 'KR',
'KW' = 'KW',
'KY' = 'KY',
'KZ' = 'KZ',
'LA' = 'LA',
'LB' = 'LB',
'LC' = 'LC',
'LI' = 'LI',
'LK' = 'LK',
'LR' = 'LR',
'LS' = 'LS',
'LT' = 'LT',
'LU' = 'LU',
'LV' = 'LV',
'LY' = 'LY',
'MA' = 'MA',
'MC' = 'MC',
'MD' = 'MD',
'ME' = 'ME',
'MF' = 'MF',
'MG' = 'MG',
'MH' = 'MH',
'MK' = 'MK',
'ML' = 'ML',
'MM' = 'MM',
'MN' = 'MN',
'MO' = 'MO',
'MP' = 'MP',
'MQ' = 'MQ',
'MR' = 'MR',
'MS' = 'MS',
'MT' = 'MT',
'MU' = 'MU',
'MV' = 'MV',
'MW' = 'MW',
'MX' = 'MX',
'MY' = 'MY',
'MZ' = 'MZ',
'NA' = 'NA',
'NC' = 'NC',
'NE' = 'NE',
'NF' = 'NF',
'NG' = 'NG',
'NI' = 'NI',
'NL' = 'NL',
'NO' = 'NO',
'NP' = 'NP',
'NR' = 'NR',
'NU' = 'NU',
'NZ' = 'NZ',
'OM' = 'OM',
'PA' = 'PA',
'PE' = 'PE',
'PF' = 'PF',
'PG' = 'PG',
'PH' = 'PH',
'PK' = 'PK',
'PL' = 'PL',
'PM' = 'PM',
'PN' = 'PN',
'PR' = 'PR',
'PS' = 'PS',
'PT' = 'PT',
'PW' = 'PW',
'PY' = 'PY',
'QA' = 'QA',
'RE' = 'RE',
'RO' = 'RO',
'RS' = 'RS',
'RU' = 'RU',
'RW' = 'RW',
'SA' = 'SA',
'SB' = 'SB',
'SC' = 'SC',
'SD' = 'SD',
'SE' = 'SE',
'SG' = 'SG',
'SH' = 'SH',
'SI' = 'SI',
'SJ' = 'SJ',
'SK' = 'SK',
'SL' = 'SL',
'SM' = 'SM',
'SN' = 'SN',
'SO' = 'SO',
'SR' = 'SR',
'SS' = 'SS',
'ST' = 'ST',
'SV' = 'SV',
'SX' = 'SX',
'SY' = 'SY',
'SZ' = 'SZ',
'TC' = 'TC',
'TD' = 'TD',
'TF' = 'TF',
'TG' = 'TG',
'TH' = 'TH',
'TJ' = 'TJ',
'TK' = 'TK',
'TL' = 'TL',
'TM' = 'TM',
'TN' = 'TN',
'TO' = 'TO',
'TR' = 'TR',
'TT' = 'TT',
'TV' = 'TV',
'TW' = 'TW',
'TZ' = 'TZ',
'UA' = 'UA',
'UG' = 'UG',
'UM' = 'UM',
'US' = 'US',
'UY' = 'UY',
'UZ' = 'UZ',
'VA' = 'VA',
'VC' = 'VC',
'VE' = 'VE',
'VG' = 'VG',
'VI' = 'VI',
'VN' = 'VN',
'VU' = 'VU',
'WF' = 'WF',
'WS' = 'WS',
'YE' = 'YE',
'YT' = 'YT',
'ZA' = 'ZA',
'ZM' = 'ZM',
'ZW' = 'ZW',
}

export enum ShippingListStatusEnum {
'STATUS_ACCEPTED' = 'STATUS_ACCEPTED',
'STATUS_CANCELED' = 'STATUS_CANCELED',
'STATUS_DELIVERED' = 'STATUS_DELIVERED',
'STATUS_INIT' = 'STATUS_INIT',
'STATUS_PENDING_CONFIRMATION' = 'STATUS_PENDING_CONFIRMATION',
'STATUS_REFUNDED' = 'STATUS_REFUNDED',
'STATUS_SUBMITTED' = 'STATUS_SUBMITTED',
'STATUS_TRANSPORT' = 'STATUS_TRANSPORT',
'STATUS_UNDELIVERED' = 'STATUS_UNDELIVERED',
'STATUS_UNKNOWN' = 'STATUS_UNKNOWN',
'STATUS_WAITING_FOR_ORDERING' = 'STATUS_WAITING_FOR_ORDERING',
}

export enum ShippingShippingListListShippingProviderEnum {
'CUSTOM' = 'CUSTOM',
'DHL24_DROP_OFF' = 'DHL24_DROP_OFF',
'DHL24_PICKUP' = 'DHL24_PICKUP',
'DHL_FREIGHT_PICKUP' = 'DHL_FREIGHT_PICKUP',
'DHL_INTERNATIONAL_DROPOFF' = 'DHL_INTERNATIONAL_DROPOFF',
'DPD_BELGIUM_DROPOFF' = 'DPD_BELGIUM_DROPOFF',
'DPD_GEO_API_DROPOFF' = 'DPD_GEO_API_DROPOFF',
'DPD_GEO_API_PICKUP' = 'DPD_GEO_API_PICKUP',
'DPD_HU_DROPOFF' = 'DPD_HU_DROPOFF',
'DPD_HU_PICKUP' = 'DPD_HU_PICKUP',
'DPD_REG_PRIJEMCE_DROPOFF' = 'DPD_REG_PRIJEMCE_DROPOFF',
'DPD_REG_PRIJEMCE_PICKUP' = 'DPD_REG_PRIJEMCE_PICKUP',
'DPD_SK_DROPOFF' = 'DPD_SK_DROPOFF',
'DPD_SK_PICKUP' = 'DPD_SK_PICKUP',
'FOXPOST_RETURNS' = 'FOXPOST_RETURNS',
'GEIS_PICKUP' = 'GEIS_PICKUP',
'GLS_ISRS' = 'GLS_ISRS',
'GLS_PICKUP' = 'GLS_PICKUP',
'GLS_POLAND_API_DROPOFF' = 'GLS_POLAND_API_DROPOFF',
'INPOST_DROP_OFF' = 'INPOST_DROP_OFF',
'INPOST_PICKUP' = 'INPOST_PICKUP',
'IN_PERSON' = 'IN_PERSON',
'LIFTAGO' = 'LIFTAGO',
'MY_GLS_BOX_CZ' = 'MY_GLS_BOX_CZ',
'MY_GLS_DROP_OFF_CZ' = 'MY_GLS_DROP_OFF_CZ',
'MY_GLS_DROP_OFF_HU' = 'MY_GLS_DROP_OFF_HU',
'MY_GLS_DROP_OFF_SK' = 'MY_GLS_DROP_OFF_SK',
'MY_GLS_PICKUP_CZ' = 'MY_GLS_PICKUP_CZ',
'MY_GLS_PICKUP_HR' = 'MY_GLS_PICKUP_HR',
'MY_GLS_PICKUP_HU' = 'MY_GLS_PICKUP_HU',
'MY_GLS_PICKUP_SI' = 'MY_GLS_PICKUP_SI',
'MY_GLS_PICKUP_SK' = 'MY_GLS_PICKUP_SK',
'MY_PPL_CPL_DROPOFF' = 'MY_PPL_CPL_DROPOFF',
'MY_PPL_CPL_PICKUP' = 'MY_PPL_CPL_PICKUP',
'MY_PPL_PICKUP' = 'MY_PPL_PICKUP',
'PACKETA_CLAIM_ASSISTANT' = 'PACKETA_CLAIM_ASSISTANT',
'PPL_RETURN_CONNECT_DROPOFF' = 'PPL_RETURN_CONNECT_DROPOFF',
'PPL_RETURN_CONNECT_PICKUP' = 'PPL_RETURN_CONNECT_PICKUP',
'RABEN_FREIGHT' = 'RABEN_FREIGHT',
'SPS_DROPOFF' = 'SPS_DROPOFF',
'UPS_PICKUP' = 'UPS_PICKUP',
}

export enum TicketProductsListTicketCountryEnum {
'AD' = 'AD',
'AE' = 'AE',
'AF' = 'AF',
'AG' = 'AG',
'AI' = 'AI',
'AL' = 'AL',
'AM' = 'AM',
'AO' = 'AO',
'AQ' = 'AQ',
'AR' = 'AR',
'AS' = 'AS',
'AT' = 'AT',
'AU' = 'AU',
'AW' = 'AW',
'AX' = 'AX',
'AZ' = 'AZ',
'BA' = 'BA',
'BB' = 'BB',
'BD' = 'BD',
'BE' = 'BE',
'BF' = 'BF',
'BG' = 'BG',
'BH' = 'BH',
'BI' = 'BI',
'BJ' = 'BJ',
'BL' = 'BL',
'BM' = 'BM',
'BN' = 'BN',
'BO' = 'BO',
'BQ' = 'BQ',
'BR' = 'BR',
'BS' = 'BS',
'BT' = 'BT',
'BV' = 'BV',
'BW' = 'BW',
'BY' = 'BY',
'BZ' = 'BZ',
'CA' = 'CA',
'CC' = 'CC',
'CD' = 'CD',
'CF' = 'CF',
'CG' = 'CG',
'CH' = 'CH',
'CI' = 'CI',
'CK' = 'CK',
'CL' = 'CL',
'CM' = 'CM',
'CN' = 'CN',
'CO' = 'CO',
'CR' = 'CR',
'CU' = 'CU',
'CV' = 'CV',
'CW' = 'CW',
'CX' = 'CX',
'CY' = 'CY',
'CZ' = 'CZ',
'DE' = 'DE',
'DJ' = 'DJ',
'DK' = 'DK',
'DM' = 'DM',
'DO' = 'DO',
'DZ' = 'DZ',
'EC' = 'EC',
'EE' = 'EE',
'EG' = 'EG',
'EH' = 'EH',
'ER' = 'ER',
'ES' = 'ES',
'ET' = 'ET',
'FI' = 'FI',
'FJ' = 'FJ',
'FK' = 'FK',
'FM' = 'FM',
'FO' = 'FO',
'FR' = 'FR',
'GA' = 'GA',
'GB' = 'GB',
'GD' = 'GD',
'GE' = 'GE',
'GF' = 'GF',
'GG' = 'GG',
'GH' = 'GH',
'GI' = 'GI',
'GL' = 'GL',
'GM' = 'GM',
'GN' = 'GN',
'GP' = 'GP',
'GQ' = 'GQ',
'GR' = 'GR',
'GS' = 'GS',
'GT' = 'GT',
'GU' = 'GU',
'GW' = 'GW',
'GY' = 'GY',
'HK' = 'HK',
'HM' = 'HM',
'HN' = 'HN',
'HR' = 'HR',
'HT' = 'HT',
'HU' = 'HU',
'ID' = 'ID',
'IE' = 'IE',
'IL' = 'IL',
'IM' = 'IM',
'IN' = 'IN',
'IO' = 'IO',
'IQ' = 'IQ',
'IR' = 'IR',
'IS' = 'IS',
'IT' = 'IT',
'JE' = 'JE',
'JM' = 'JM',
'JO' = 'JO',
'JP' = 'JP',
'KE' = 'KE',
'KG' = 'KG',
'KH' = 'KH',
'KI' = 'KI',
'KM' = 'KM',
'KN' = 'KN',
'KP' = 'KP',
'KR' = 'KR',
'KW' = 'KW',
'KY' = 'KY',
'KZ' = 'KZ',
'LA' = 'LA',
'LB' = 'LB',
'LC' = 'LC',
'LI' = 'LI',
'LK' = 'LK',
'LR' = 'LR',
'LS' = 'LS',
'LT' = 'LT',
'LU' = 'LU',
'LV' = 'LV',
'LY' = 'LY',
'MA' = 'MA',
'MC' = 'MC',
'MD' = 'MD',
'ME' = 'ME',
'MF' = 'MF',
'MG' = 'MG',
'MH' = 'MH',
'MK' = 'MK',
'ML' = 'ML',
'MM' = 'MM',
'MN' = 'MN',
'MO' = 'MO',
'MP' = 'MP',
'MQ' = 'MQ',
'MR' = 'MR',
'MS' = 'MS',
'MT' = 'MT',
'MU' = 'MU',
'MV' = 'MV',
'MW' = 'MW',
'MX' = 'MX',
'MY' = 'MY',
'MZ' = 'MZ',
'NA' = 'NA',
'NC' = 'NC',
'NE' = 'NE',
'NF' = 'NF',
'NG' = 'NG',
'NI' = 'NI',
'NL' = 'NL',
'NO' = 'NO',
'NP' = 'NP',
'NR' = 'NR',
'NU' = 'NU',
'NZ' = 'NZ',
'OM' = 'OM',
'PA' = 'PA',
'PE' = 'PE',
'PF' = 'PF',
'PG' = 'PG',
'PH' = 'PH',
'PK' = 'PK',
'PL' = 'PL',
'PM' = 'PM',
'PN' = 'PN',
'PR' = 'PR',
'PS' = 'PS',
'PT' = 'PT',
'PW' = 'PW',
'PY' = 'PY',
'QA' = 'QA',
'RE' = 'RE',
'RO' = 'RO',
'RS' = 'RS',
'RU' = 'RU',
'RW' = 'RW',
'SA' = 'SA',
'SB' = 'SB',
'SC' = 'SC',
'SD' = 'SD',
'SE' = 'SE',
'SG' = 'SG',
'SH' = 'SH',
'SI' = 'SI',
'SJ' = 'SJ',
'SK' = 'SK',
'SL' = 'SL',
'SM' = 'SM',
'SN' = 'SN',
'SO' = 'SO',
'SR' = 'SR',
'SS' = 'SS',
'ST' = 'ST',
'SV' = 'SV',
'SX' = 'SX',
'SY' = 'SY',
'SZ' = 'SZ',
'TC' = 'TC',
'TD' = 'TD',
'TF' = 'TF',
'TG' = 'TG',
'TH' = 'TH',
'TJ' = 'TJ',
'TK' = 'TK',
'TL' = 'TL',
'TM' = 'TM',
'TN' = 'TN',
'TO' = 'TO',
'TR' = 'TR',
'TT' = 'TT',
'TV' = 'TV',
'TW' = 'TW',
'TZ' = 'TZ',
'UA' = 'UA',
'UG' = 'UG',
'UM' = 'UM',
'US' = 'US',
'UY' = 'UY',
'UZ' = 'UZ',
'VA' = 'VA',
'VC' = 'VC',
'VE' = 'VE',
'VG' = 'VG',
'VI' = 'VI',
'VN' = 'VN',
'VU' = 'VU',
'WF' = 'WF',
'WS' = 'WS',
'YE' = 'YE',
'YT' = 'YT',
'ZA' = 'ZA',
'ZM' = 'ZM',
'ZW' = 'ZW',
}

export enum TicketsListCountryEnum {
'AD' = 'AD',
'AE' = 'AE',
'AF' = 'AF',
'AG' = 'AG',
'AI' = 'AI',
'AL' = 'AL',
'AM' = 'AM',
'AO' = 'AO',
'AQ' = 'AQ',
'AR' = 'AR',
'AS' = 'AS',
'AT' = 'AT',
'AU' = 'AU',
'AW' = 'AW',
'AX' = 'AX',
'AZ' = 'AZ',
'BA' = 'BA',
'BB' = 'BB',
'BD' = 'BD',
'BE' = 'BE',
'BF' = 'BF',
'BG' = 'BG',
'BH' = 'BH',
'BI' = 'BI',
'BJ' = 'BJ',
'BL' = 'BL',
'BM' = 'BM',
'BN' = 'BN',
'BO' = 'BO',
'BQ' = 'BQ',
'BR' = 'BR',
'BS' = 'BS',
'BT' = 'BT',
'BV' = 'BV',
'BW' = 'BW',
'BY' = 'BY',
'BZ' = 'BZ',
'CA' = 'CA',
'CC' = 'CC',
'CD' = 'CD',
'CF' = 'CF',
'CG' = 'CG',
'CH' = 'CH',
'CI' = 'CI',
'CK' = 'CK',
'CL' = 'CL',
'CM' = 'CM',
'CN' = 'CN',
'CO' = 'CO',
'CR' = 'CR',
'CU' = 'CU',
'CV' = 'CV',
'CW' = 'CW',
'CX' = 'CX',
'CY' = 'CY',
'CZ' = 'CZ',
'DE' = 'DE',
'DJ' = 'DJ',
'DK' = 'DK',
'DM' = 'DM',
'DO' = 'DO',
'DZ' = 'DZ',
'EC' = 'EC',
'EE' = 'EE',
'EG' = 'EG',
'EH' = 'EH',
'ER' = 'ER',
'ES' = 'ES',
'ET' = 'ET',
'FI' = 'FI',
'FJ' = 'FJ',
'FK' = 'FK',
'FM' = 'FM',
'FO' = 'FO',
'FR' = 'FR',
'GA' = 'GA',
'GB' = 'GB',
'GD' = 'GD',
'GE' = 'GE',
'GF' = 'GF',
'GG' = 'GG',
'GH' = 'GH',
'GI' = 'GI',
'GL' = 'GL',
'GM' = 'GM',
'GN' = 'GN',
'GP' = 'GP',
'GQ' = 'GQ',
'GR' = 'GR',
'GS' = 'GS',
'GT' = 'GT',
'GU' = 'GU',
'GW' = 'GW',
'GY' = 'GY',
'HK' = 'HK',
'HM' = 'HM',
'HN' = 'HN',
'HR' = 'HR',
'HT' = 'HT',
'HU' = 'HU',
'ID' = 'ID',
'IE' = 'IE',
'IL' = 'IL',
'IM' = 'IM',
'IN' = 'IN',
'IO' = 'IO',
'IQ' = 'IQ',
'IR' = 'IR',
'IS' = 'IS',
'IT' = 'IT',
'JE' = 'JE',
'JM' = 'JM',
'JO' = 'JO',
'JP' = 'JP',
'KE' = 'KE',
'KG' = 'KG',
'KH' = 'KH',
'KI' = 'KI',
'KM' = 'KM',
'KN' = 'KN',
'KP' = 'KP',
'KR' = 'KR',
'KW' = 'KW',
'KY' = 'KY',
'KZ' = 'KZ',
'LA' = 'LA',
'LB' = 'LB',
'LC' = 'LC',
'LI' = 'LI',
'LK' = 'LK',
'LR' = 'LR',
'LS' = 'LS',
'LT' = 'LT',
'LU' = 'LU',
'LV' = 'LV',
'LY' = 'LY',
'MA' = 'MA',
'MC' = 'MC',
'MD' = 'MD',
'ME' = 'ME',
'MF' = 'MF',
'MG' = 'MG',
'MH' = 'MH',
'MK' = 'MK',
'ML' = 'ML',
'MM' = 'MM',
'MN' = 'MN',
'MO' = 'MO',
'MP' = 'MP',
'MQ' = 'MQ',
'MR' = 'MR',
'MS' = 'MS',
'MT' = 'MT',
'MU' = 'MU',
'MV' = 'MV',
'MW' = 'MW',
'MX' = 'MX',
'MY' = 'MY',
'MZ' = 'MZ',
'NA' = 'NA',
'NC' = 'NC',
'NE' = 'NE',
'NF' = 'NF',
'NG' = 'NG',
'NI' = 'NI',
'NL' = 'NL',
'NO' = 'NO',
'NP' = 'NP',
'NR' = 'NR',
'NU' = 'NU',
'NZ' = 'NZ',
'OM' = 'OM',
'PA' = 'PA',
'PE' = 'PE',
'PF' = 'PF',
'PG' = 'PG',
'PH' = 'PH',
'PK' = 'PK',
'PL' = 'PL',
'PM' = 'PM',
'PN' = 'PN',
'PR' = 'PR',
'PS' = 'PS',
'PT' = 'PT',
'PW' = 'PW',
'PY' = 'PY',
'QA' = 'QA',
'RE' = 'RE',
'RO' = 'RO',
'RS' = 'RS',
'RU' = 'RU',
'RW' = 'RW',
'SA' = 'SA',
'SB' = 'SB',
'SC' = 'SC',
'SD' = 'SD',
'SE' = 'SE',
'SG' = 'SG',
'SH' = 'SH',
'SI' = 'SI',
'SJ' = 'SJ',
'SK' = 'SK',
'SL' = 'SL',
'SM' = 'SM',
'SN' = 'SN',
'SO' = 'SO',
'SR' = 'SR',
'SS' = 'SS',
'ST' = 'ST',
'SV' = 'SV',
'SX' = 'SX',
'SY' = 'SY',
'SZ' = 'SZ',
'TC' = 'TC',
'TD' = 'TD',
'TF' = 'TF',
'TG' = 'TG',
'TH' = 'TH',
'TJ' = 'TJ',
'TK' = 'TK',
'TL' = 'TL',
'TM' = 'TM',
'TN' = 'TN',
'TO' = 'TO',
'TR' = 'TR',
'TT' = 'TT',
'TV' = 'TV',
'TW' = 'TW',
'TZ' = 'TZ',
'UA' = 'UA',
'UG' = 'UG',
'UM' = 'UM',
'US' = 'US',
'UY' = 'UY',
'UZ' = 'UZ',
'VA' = 'VA',
'VC' = 'VC',
'VE' = 'VE',
'VG' = 'VG',
'VI' = 'VI',
'VN' = 'VN',
'VU' = 'VU',
'WF' = 'WF',
'WS' = 'WS',
'YE' = 'YE',
'YT' = 'YT',
'ZA' = 'ZA',
'ZM' = 'ZM',
'ZW' = 'ZW',
}

export enum TicketsListCustomerRatingEnum {
'VALUE_0' = 0,
'VALUE_1' = 1,
'VALUE_2' = 2,
}

export enum TicketsListLanguageEnum {
'BG' = 'bg',
'CS' = 'cs',
'DA' = 'da',
'DE' = 'de',
'DE-AT' = 'de-at',
'DE-CH' = 'de-ch',
'EL' = 'el',
'EN' = 'en',
'ES' = 'es',
'ET' = 'et',
'FI' = 'fi',
'FR' = 'fr',
'FR-BE' = 'fr-be',
'FR-CH' = 'fr-ch',
'HR' = 'hr',
'HU' = 'hu',
'IT' = 'it',
'IT-CH' = 'it-ch',
'LT' = 'lt',
'LV' = 'lv',
'NB' = 'nb',
'NL' = 'nl',
'NL-BE' = 'nl-be',
'PL' = 'pl',
'PT' = 'pt',
'RO' = 'ro',
'SK' = 'sk',
'SL' = 'sl',
'SR' = 'sr',
'SV' = 'sv',
'UK' = 'uk',
}

export enum TicketsListOrderingEnum {
'-CODE' = '-code',
'-CREATED_AT' = '-created_at',
'-CUSTOMER_NAME' = '-customer_name',
'CODE' = 'code',
'CREATED_AT' = 'created_at',
'CUSTOMER_NAME' = 'customer_name',
}

export enum TicketsListShippingStatusEnum {
'CANCELED' = 'CANCELED',
'CONFIRMATION_REQUIRED' = 'CONFIRMATION_REQUIRED',
'DECLINED' = 'DECLINED',
'FAILURE' = 'FAILURE',
'FINISHED' = 'FINISHED',
'REFUNDED' = 'REFUNDED',
'SYNCING' = 'SYNCING',
'VOIDED' = 'VOIDED',
'WAITING' = 'WAITING',
}

export enum TicketsHistoryListTypeEnum {
'ACTIVITY' = 'ACTIVITY',
'ALL' = 'ALL',
'DOCUMENT' = 'DOCUMENT',
'INTERNAL_NOTE' = 'INTERNAL_NOTE',
'MESSAGES' = 'MESSAGES',
'REFUND_REQUEST' = 'REFUND_REQUEST',
'RETINO_SHIPPING' = 'RETINO_SHIPPING',
'SMS_MESSAGES' = 'SMS_MESSAGES',
'SYSTEM' = 'SYSTEM',
}

export enum TriggerLogsListStateEnum {
'CAN_RETRY' = 'CAN_RETRY',
'FAILED' = 'FAILED',
'SUCCESS' = 'SUCCESS',
}

}
